export const constantes = {
  naturezaFreteList: [
    "Operações de vendas, com ônus suportado pelo estabelecimento",
    "Operações de vendas, com ônus suportado pelo adquirinte",
    "Operações de compras (bens para revenda, matérias-primas e outros)",
    "Transferência de produtos acabados entre estabelecimentos da mesma empresa",
    "Transferência de produtos em elaboração entre estabelecimentos da pessoa jurídica",
  ],
  tipoFreteList: [
    "CT-e Normal",
    "CT-e de Complemento de Valores",
    "CT-e de Anulação de Valores",
    "CT-e Substituto",
    "Não se aplica",
  ],
  modalidadeFreteList: [
    "Contratação do frete por conta do remetente (CIF)",
    "Contratação do frete por conta do destinatário (FOB)",
    "Contratação do frete por conta de terceiros",
    "Transporte próprio por conta do remetente",
    "Transporte próprio por conta do destinatário",
    "Sem ocorrência de transporte",
  ],
  estados: [
    {
      id: 1,
      nome: "Acre",
      sigla: "AC",
      codigo: 12
    },
    {
      id: 2,
      nome: "Alagoas",
      sigla: "AL",
      codigo: 27
    },
    {
      id: 3,
      nome: "Amazonas",
      sigla: "AM",
      codigo: 13
    },
    {
      id: 4,
      nome: "Amapá",
      sigla: "AP",
      codigo: 16
    },
    {
      id: 5,
      nome: "Bahia",
      sigla: "BA",
      codigo: 29
    },
    {
      id: 6,
      nome: "Ceará",
      sigla: "CE",
      codigo: 23
    },
    {
      id: 7,
      nome: "Distrito Federal",
      sigla: "DF",
      codigo: 53
    },
    {
      id: 8,
      nome: "Espirito Santo",
      sigla: "ES",
      codigo: 32
    },
    {
      id: 9,
      nome: "Goiás",
      sigla: "GO",
      codigo: 52
    },
    {
      id: 10,
      nome: "Maranhão",
      sigla: "MA",
      codigo: 21
    },
    {
      id: 11,
      nome: "Minas Gerais",
      sigla: "MG",
      codigo: 31
    },
    {
      id: 12,
      nome: "Mato Grosso do Sul",
      sigla: "MS",
      codigo: 50
    },
    {
      id: 13,
      nome: "Mato Grosso",
      sigla: "MT",
      codigo: 51
    },
    {
      id: 14,
      nome: "Pará",
      sigla: "PA",
      codigo: 15
    },
    {
      id: 15,
      nome: "Paraíba",
      sigla: "PB",
      codigo: 25
    },
    {
      id: 16,
      nome: "Pernambuco",
      sigla: "PE",
      codigo: 26
    },
    {
      id: 17,
      nome: "Piauí",
      sigla: "PI",
      codigo: 22
    },
    {
      id: 18,
      nome: "Paraná",
      sigla: "PR",
      codigo: 41
    },
    {
      id: 19,
      nome: "Rio de Janeiro",
      sigla: "RJ",
      codigo: 33
    },
    {
      id: 20,
      nome: "Rio Grande do Norte",
      sigla: "RN",
      codigo: 24
    },
    {
      id: 21,
      nome: "Rondônia",
      sigla: "RO",
      codigo: 11
    },
    {
      id: 22,
      nome: "Roraima",
      sigla: "RR",
      codigo: 14
    },
    {
      id: 23,
      nome: "Rio Grande do Sul",
      sigla: "RS",
      codigo: 43
    },
    {
      id: 24,
      nome: "Santa Catarina",
      sigla: "SC",
      codigo: 42
    },
    {
      id: 25,
      nome: "Sergipe",
      sigla: "SE",
      codigo: 28
    },
    {
      id: 26,
      nome: "São Paulo",
      sigla: "SP",
      codigo: 35
    },
    {
      id: 27,
      nome: "Tocantins",
      sigla: "TO",
      codigo: 17
    },
  ],
};
